import { translations } from '../../../../configs/translations'
import { useStore } from '../../../../store/store'
import { FineTuningSetting } from './fineTuningSetting/FineTuningSetting'
import './FineTuningSettingCategory.css'
import { FineTuningSettingCategoryProps } from './FineTuningSettingCategory.types'

export const FineTuningSettingCategory = ({
	categoryIndex,
	name,
	activeSetting,
	setActiveSetting,
	category,
	setFineTuningSettingsRef,
	profileName,
	activeComponent,
}: FineTuningSettingCategoryProps) => {

	const language = useStore(state => state.language)
	const t = translations[language]

	const calculateMargin = (settingIndex: number) => {
		console.log(settingIndex, categoryIndex)
		return categoryIndex + settingIndex * 40
	}

	return (
		<div className='fine-tuning-setting-category'>

			<div className='fine-tuning-setting-category-header'>
				<p className='fine-tuning-setting-category-header-h1'>{t[name as keyof typeof t]}</p>

				<div className='fine-tuning-setting-category-inner'>
					<p className='fine-tuning-setting-category-inner-min-text'>{t[category.minText as keyof typeof t]}</p>
					<p className='fine-tuning-setting-category-inner-max-text'>{t[category.maxText as keyof typeof t]}</p>
				</div>

			</div>

			<div className='fine-tuning-setting-category-body'>

				<div className='fine-tuning-settings'>

					{
						category.settings.map((setting, index) => (
							<FineTuningSetting
								key={index}
								name={setting.name}
								translation={setting.translation}
								type={activeSetting === setting.name ? "active" : "default"}
								symbol={setting.symbol}
								onHover={() => setActiveSetting(setting.name)}
								onUnhover={() => setActiveSetting(undefined)}
								slider={{
									name: setting.name,
									min: setting.minValue,
									max: setting.maxValue,
									step: setting.step,
									initialValue: setting.currentValue,
									showCenterMarker: setting.isMidShown
								}}
								information={setting.information}
								setFineTuningSettingsRef={setFineTuningSettingsRef}
								profileName={profileName}
								activeComponent={activeComponent}
							/>
						))
					}

				</div>

			</div>

		</div>
	)
}